import React from "react";
import get from "lodash/get";

import "./termsAndConditions.css";
import { sendClickToMerchant } from "../../utils/sendClickToMerchant";
import { WidgetConfig, WidgetProps } from "../Widget/Widget";
import { getHorizontalAlignment } from "../../utils/getHorizontalAlignment";

export interface TermsAndConditionsProps extends WidgetProps {
  config: WidgetConfig;
  isEditing: boolean;
  toggleTermsAndConditionsVisibility: () => void;
  configName: string;
  style: React.CSSProperties;
}

interface TermsAndConditionsState {
  isTermsAndConditionsVisible: boolean;
}

export class TermsAndConditions extends React.PureComponent<
  TermsAndConditionsProps,
  TermsAndConditionsState
> {
  component: HTMLDivElement | null;
  state: TermsAndConditionsState = { isTermsAndConditionsVisible: false };
  tAndC: HTMLDivElement | null;

  componentDidMount() {
    if (this.tAndC) {
      this.tAndC.innerHTML =
        this.tAndC.innerHTML + this.props.config.settings.termsAndConditions;
    }

    if (this.component && this.props.horizontalAlign) {
      this.component.style.left = getHorizontalAlignment(
        window.document.body.clientWidth,
        this.component.getBoundingClientRect(),
        this.props.horizontalAlign,
        this.props.config
      );
    }
  }

  componentDidUpdate(
    prevProps: TermsAndConditionsProps,
    prevState: TermsAndConditionsState
  ) {
    if (
      !prevState.isTermsAndConditionsVisible &&
      this.props.config.settings.termsAndConditions &&
      this.tAndC
    ) {
      this.tAndC.innerHTML =
        this.tAndC.innerHTML + this.props.config.settings.termsAndConditions;
    }

    if (
      this.component &&
      prevProps.horizontalAlign !== this.props.horizontalAlign
    ) {
      this.component.style.left = getHorizontalAlignment(
        window.document.body.clientWidth,
        this.component.getBoundingClientRect(),
        this.props.horizontalAlign,
        this.props.config
      );
    }
  }

  onKeyDown = (event: React.KeyboardEvent) => {
    const { isEditing } = this.props;

    if (event.key === "Enter") {
      if (!isEditing && this.props.config.settings.termsAndConditions) {
        this.setState((prevState) => ({
          isTermsAndConditionsVisible: !prevState.isTermsAndConditionsVisible,
        }));
      }
    }
  };

  toggleTermsAndConditionsVisibility = (
    event: React.MouseEvent<HTMLDivElement>
  ) => {
    const { config, configName, isEditing } = this.props;
    const isLink =
      get(config, `[${configName}]specialType`) === "termsAndConditionsLink";
    const termsAndConditionsUrl = get(
      config,
      `[${configName}]action.args.url`
    ) as string;

    if (isEditing) {
      sendClickToMerchant(event, configName);
    }

    if (isLink && termsAndConditionsUrl && !isEditing) {
      window.open(termsAndConditionsUrl);
    } else if (!isEditing && this.props.config.settings.termsAndConditions) {
      this.setState({
        isTermsAndConditionsVisible: !this.state.isTermsAndConditionsVisible,
      });
    }
  };

  render() {
    const { config, configName, style } = this.props;
    const isLink =
      get(config, `[${configName}]specialType`) === "termsAndConditionsLink";

    return (
      <>
        <div
          className="terms-and-conditions-action"
          onClick={this.toggleTermsAndConditionsVisibility}
          onKeyDown={this.onKeyDown}
          style={style}
          tabIndex={0}
          ref={(component) => (this.component = component)}
          role="link"
        >
          Terms
          {isLink && (
            <span className="screen-reader-only">(opens in a new window)</span>
          )}
        </div>
        {this.state.isTermsAndConditionsVisible && (
          <div
            className="terms-and-conditions-container"
            onClick={(event: React.MouseEvent<HTMLDivElement>) =>
              sendClickToMerchant(event, configName)
            }
            aria-label="Terms and Conditions"
          >
            <div className="terms-and-conditions-close-container">
              <img
                className="terms-and-conditions-close-button"
                src="https://widget-assets.fbot.me/builder/closeBlack.svg"
                width="20px"
                onClick={this.toggleTermsAndConditionsVisibility}
                onKeyDown={this.onKeyDown}
                alt="Close Terms and Conditions"
                tabIndex={0}
              />
            </div>
            <div
              className="terms-and-conditions-content"
              ref={(tAndC) => (this.tAndC = tAndC)}
            />
          </div>
        )}
      </>
    );
  }
}
